import React, { SVGProps } from 'react';

// Kim cương package cho tab Packages; vẽ trong khung 24 rồi scale lên 56 như các icon tab khác
const PackageDiamondPaths = ({ fill }: { fill: string }) => (
  <g transform='matrix(1 0 0 -1 0 24)'>
    <path transform='translate(-0.02 0.018)' d='M24.04 12.875L19.773 19.511L4.268 19.511L0 12.875L12.02 0L24.04 12.875ZM1.775 13.035L5.035 18.105L19.005 18.105L22.266 13.035L12.02 2.061L1.775 13.035Z' fill={fill} />
    <path transform='translate(0.867 12.27)' d='M22.266 0L22.266 1.406L0 1.406L0 0L22.266 0Z' fill={fill} />
    <path transform='translate(11.402 12.603)' d='M4.826 0.741L1.195 6.594L0 5.853L3.631 0L4.826 0.741Z' fill={fill} />
    <path transform='translate(7.772 12.603)' d='M4.826 5.853L3.631 6.594L0 0.741L1.195 0L4.826 5.853Z' fill={fill} />
    <path transform='translate(15.038 12.595)' d='M4.923 5.853L3.738 6.61L0 0.757L1.185 0L4.923 5.853Z' fill={fill} />
    <path transform='translate(4.039 12.595)' d='M4.923 0.757L1.185 6.61L0 5.853L3.738 0L4.923 0.757Z' fill={fill} />
    <path transform='translate(11.328 0.844)' d='M4.976 11.925L3.631 12.334L0 0.41L1.345 0L4.976 11.925Z' fill={fill} />
    <path transform='translate(7.697 0.844)' d='M4.976 0.41L1.345 12.334L0 11.925L3.631 0L4.976 0.41Z' fill={fill} />
    <path transform='translate(11.297 21.187)' d='M1.406 0L1.406 2.813L0 2.813L0 0L1.406 0Z' fill={fill} />
    <path transform='translate(15.524 21.008)' d='M2.983 1.989L1.989 2.983L0 0.994L0.994 0L2.983 1.989Z' fill={fill} />
    <path transform='translate(5.493 21.008)' d='M2.983 0.994L0.994 2.983L0 1.989L1.989 0L2.983 0.994Z' fill={fill} />
  </g>
);

const CardPackageV2 = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width='56' height='56' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <PackageDiamondPaths fill={props.fill || '#EBA33B'} />
    </svg>
  );
};

export const CardPackageV2Active = () => {
  return (
    <svg width='56' height='56' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <PackageDiamondPaths fill='white' />
    </svg>
  );
};

export default CardPackageV2;
